import { gql } from "@apollo/client";

export const GET_CONVERSATION_BY_REMITTANCE_ITEM_ID = gql`
  query GetConversationByRemittanceItemId($params: GetConversationByRemittanceIdInput!) {
    conversationByRemittanceItemId(params: $params) {
      id
      remittanceItemId
      participants {
        email
        firstName
        lastName
        fullName
        avatar
        isDeleted
        participantId
      }
      createdAt
      updatedAt
    }
  }
`;
